import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  colors: {
    primary: '#2563eb', // Modern Blue
    secondary: '#f59e0b', // Amber Gold
    accent: '#10b981', // Emerald Green
  },
  loading: false,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeColors: (state, action) => {
      state.colors = { ...state.colors, ...action.payload };
    },
    setThemeLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetTheme: (state) => {
      state.colors = initialState.colors;
    },
  },
});

export const { setThemeColors, setThemeLoading, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;
